import { render, staticRenderFns } from "./text-field.vue?vue&type=template&id=bbf2724e"
import script from "./text-field.vue?vue&type=script&lang=ts"
export * from "./text-field.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports